import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import { Dashboard } from './pages/Dashboard';
import { SideBar } from './components/sidebar';
import { Leagues } from './pages/leagues/Leagues';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { League } from './pages/leagues/League';
import { UpcomingMatches } from './pages/matches/UpcomingMatches';
import { LiveMatches } from './pages/matches/LiveMatches';
import { ChallengeSettings } from './pages/settings/ChallengeSettings/ChallengeSettings';
import { SignIn } from './pages/auth/SignIn/SignIn';
import { SignUp } from './pages/auth/SignUp/SignUp';
import { Users } from './pages/users/Users';
import { AppSettings } from './pages/settings/AppSettings/AppSettings';
import { GroupManagementComponent } from './pages/settings/components/GroupManagementComponent/GroupManagementComponent';
import LiveQuiz from './pages/liveQuiz';
import MediaLibrary from './pages/mediaLibrary';
import Reports from './pages/reports';
import Competitions from './pages/competitions';

function App() {
  return (
    <Provider store={store}>
      <div className="App">
        <Router>
          <div className="container">
            <div className="sidebar">
              <SideBar />
            </div>
            <div className='contentContainer'>
              <Routes>
                <Route path="/reports" element={<Reports />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/leagues" element={<Leagues />} />
                <Route path="/competitions" element={<Competitions />} />
                <Route path="/leagues/:id" element={<League />} />
                <Route path="/upcoming-matches" element={<UpcomingMatches />} />
                <Route path="/live-matches" element={<LiveMatches />} />
                <Route path="/groups" element={<GroupManagementComponent />} />
                <Route path="/challenge-settings" element={<ChallengeSettings />} />
                <Route path="/application-settings" element={<AppSettings />} />
                <Route path="/live-quiz" element={<LiveQuiz />} />
                <Route path="/sign-in" element={<SignIn />} />
                <Route path="/sign-up" element={<SignUp />} />
                <Route path="/users" element={<Users />} />
                <Route path="/media-library" element={<MediaLibrary />} />
                <Route path={'*'} element={<Leagues />} />
              </Routes>
            </div>
          </div>
        </Router>
      </div>
    </Provider>
  );
}

export default App;
